import Notifications from '../components/Notifications'

export function renderSuccessNotification(message) {
  return Notifications.success({ message: message })
}

export function renderErrorNotification(message) {
  return Notifications.error({ message: message })
}
